<template>
	<div class="c-share-page">
		<Board type="public" :slug="slug"></Board>
	</div>
</template>

<script>
import Board from '@swipekit/components/board';

export default {
	components: {
		Board,
	},

	props: {
		slug: {},
	},

	computed: {
		slug: function () {
			if (this.$route.params) {
				return this.$route.params.slug;
			} else {
				return '';
			}
		},
	},
};
</script>

<style lang="scss">
.c-share-page {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 999;
	background-color: #fff;
}
</style>
